import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton, { Debtbutton } from "../../forms/button";
import { connect } from "react-redux";
import {
  YES,
  EXISTING,
  NEW,
  REGULAR,
  PURCHASE,
  NO,
  ALL,
  ADDITIONAL_PURCHASE,
} from "../../../store/types";
import MenuItem from "@material-ui/core/MenuItem";
import { Checkbox } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  validateSubBroker,
  getAssetClasses,
  getOtherSchemes,
  submitPurchaseData,
  showPurchaseConfirmation,
  saveTransactionDetails,
} from "../../../store/actions";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { NEW_TRANSACTION_URL } from ".";
import { BajajFund } from "../nav";
class AdditionalPurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fund: { value: { value: "189" } },
      folios: [],
      folio: { value: "" },
      schemes: [],
      schemeType: EXISTING,
      combo: { flag: "", disclamier: "", label: "" },
      isCombo: false,
      multiples: "",
      scheme: { value: "" },
      radioValue: { value: "no" },
      arnCode: { value: this.props.token },
      subArnCode: { value: "" },
      subBrokerCode: { value: "" },
      euinNo: { value: "" },
      category: { value: "" },
      bank: { value: "" },
      categories: [],
      banks: [],
      amount: { value: "" },
      combo: { flag: "", disclamier: "", label: "" },
      isCombo: false,
    };
  }

  handleFundChange = (value) => {
    if (!value) {
      this.setState({
        folios: [],
        folio: { value: "" },
        scheme: { value: "" },
        schemeType: EXISTING,
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        category: { value: "" },
        radioValue: { value: "no" },
        amount: { value: "" },
      });
      return;
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const fund = value.value;
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.pFlag === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        schemeType: EXISTING,
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        category: { value: "" },
        radioValue: { value: "no" },
        amount: { value: "" },
      });
      if (!!fund) {
        this.validateBrokerCode(fund)();
      }
    }
  };

  async componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    this.getFolios();
  }
  getFolios = () => {
    const fund = "189";
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.pFlag === YES && curr.Fund.trim() === fund) {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);

    this.setState({
      fund: { value: { value: "189" } },
      folios: Array.from(new Set(folios)),
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      schemeType: EXISTING,
      subArnCode: { value: "" },
      subBrokerCode: { value: "" },
      euinNo: { value: "" },
      category: { value: "" },
      radioValue: { value: "no" },
      amount: { value: "" },
    });
    this.validateBrokerCode(fund)();
  };

  validateBrokerCode = (fund) => async () => {
    const { subArnCode, arnCode } = this.state;
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }
    const params = {
      Fund: "189",
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);

    if (!!response && !!response.DtData && response.DtData.length > 0) {
      const getLength = response.DtData.length === 1;
      let value = {
        value: response.DtData[0].abm_agent,
        label: response.DtData[0].abm_agent,
      };
      if (!!getLength) {
        this.setState({
          euinNo: { value },
        });
      }
    } else if (!response) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `Please enter a valid Sub ARN Code`,
        },
      });
    }
  };

  handleFolioChange = (value) => {
    if (this.state.folios.length > 0) {
      if (!value) {
        this.setState({
          folio: { value: "" },
          schemes: [],
          schemeType: EXISTING,
          banks: [],
          scheme: { value: "" },
          subArnCode: { value: "" },
          subBrokerCode: { value: "" },
          euinNo: { value: "" },
          category: { value: "" },
          radioValue: { value: "no" },
          amount: { value: "" },
        });
        return;
      } else if (value.value === this.state.folio.value.value) {
        return;
      } else {
        const folio = value.value;
        const schemes = this.schemes(folio);
        this.setState({
          folio: { value },
          schemes,
          schemeType: EXISTING,
        });
      }
    } else {
      alert("No folios Found");
    }
  };

  changeEuin = (value) => {
    this.setState({
      euinNo: { value },
    });
  };

  changeValue = (label) => (event) => {
    if (label === "amount" && event.target.value.length <= 10) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "radioValue" && event.target.value === "no") {
      if (!this.state.euinNo.value) {
        this.setState({
          radioValue: { value: event.target.value },
        });
      } else {
        this.setState({
          [label]: { value: event.target.value },
          euinNo: { value: "" },
        });
      }
    } else if (
      label !== "amount" &&
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  getAssetClasses = async () => {
    const params = {
      Fund: this.state.fund.value.value,
      Folio: this.state.folio.value.value,
    };
    const assetClasses = await this.props.getAssetClasses(params);
    if (assetClasses) {
      this.setState({
        categories: assetClasses.DtData,
      });
    }
  };

  getOtherSchemes = async (value) => {
    const params = {
      schtype: REGULAR,
      category: value,
      acno: this.state.folio.value.value,
      fundCode: "189",
      customfund: "189",
      trantype: PURCHASE,
    };
    const otherSchemes = await this.props.getOtherSchemes(params);
    if (otherSchemes) {
      this.setState({
        schemes: otherSchemes.DtData,
      });
    }
  };

  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.pSchFlg === YES &&
        curr.Fund.trim() === "189" &&
        curr.Acno === folio
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };

  handleCategoryChange = (event) => {
    if (event.target.value) {
      this.getOtherSchemes(event.target.value);
      this.setState({
        category: { value: event.target.value },
        scheme: { value: "" },
      });
    } else {
      this.setState({
        category: { value: "" },
        scheme: { value: "" },
      });
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "amount") {
      if (
        parseFloat(this.state.minAmount) > parseFloat(this.state.amount.value)
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be ₹ ${this.state.minAmount} or more`,
          },
        });
      } else if (
        !!this.state.amount.value &&
        !!this.state.multiples &&
        parseFloat(this.state.amount.value) %
          parseFloat(this.state.multiples) !=
          0
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be in the multiples of ${this.state.multiples}`,
          },
        });
      }
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };

  changeSchemeType = (value) => () => {
    if (value === this.state.schemeType) {
      return;
    }
    if (value === EXISTING) {
      const schemes = this.schemes(this.state.folio.value.value);
      this.setState({
        schemeType: value,
        schemes,
        category: { value: "" },
        scheme: { value: "" },
        amount: { value: "" },
      });
    } else {
      this.setState({
        schemeType: value,
        scheme: { value: "" },
        category: { value: "" },
        amount: { value: "" },
      });
      if (!!this.state.fund.value && !!this.state.folio.value) {
        this.getAssetClasses();
        this.getOtherSchemes();
      }
    }
  };

  handleSchemeChange = (value) => {
    if (!value) {
      this.setState({
        scheme: { value: "" },
        scheme: { value: "" },
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        radioValue: { value: "no" },
        amount: { value: "" },
      });
      return;
    } else if (
      !!value &&
      !!this.state.scheme.value &&
      value.value === this.state.scheme.value.value
    ) {
      return;
    } else {
      const scheme = value.value;
      const checkCombo =
        !!scheme && !!scheme.combo_flag && scheme.combo_flag === "Y";

      this.setState({
        scheme: { value },
        minAmount: scheme.MinAmt || scheme.fm_newpur,
        amount: { value: "" },
        isCombo: !!checkCombo ? true : false,
        multiples: !!scheme && !!scheme.multiples ? scheme.multiples : "",
        combo: {
          flag: !!checkCombo ? "Y" : "N",
          disclamier: scheme.combo_disclaimer,
          label: scheme.combo_lable,
        },
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },

        radioValue: { value: "no" },
      });
    }
  };

  submit = async () => {
    const {
      funds,
      categories,
      multiples,
      schemes,
      folios,
      banks,
      arnCode,
      subArnCode,
      subBrokerCode,
      radioValue,
      euinNo,
      minAmount,
      schemeType,
      category,
      bank,
      isCombo,
      combo,
      ...others
    } = this.state;

    const keys = Object.keys(others);

    if (this.state.schemeType === NEW && this.state.category.value === "") {
      this.setState({
        category: {
          value: "",
          isError: true,
          errorMessage: "(category is mandatory*)",
        },
      });
    }
    if (
      this.state.euinNo.value === "" &&
      this.state.radioValue.value === "no"
    ) {
      this.setState({
        euinNo: {
          value: "",
          isError: true,
          errorMessage: "EUIN No is mandatory",
        },
      });
    }
    const findError = keys.every((key) => !!others[key].value);
    const arn = this.state.arnCode.value.split("-");
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "folio"
                  ? "Folio"
                  : key === "scheme"
                  ? "Scheme"
                  : key === "amount"
                  ? "Minimum Investment Amount"
                  : key
              } is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "amount": {
          this.amountField.focus();
          break;
        }
        // case "bank": {
        //   this.bankField.focus();
        //   break;
        // }
      }
    } else if (schemeType === NEW && !category.value) {
      this.setState({
        category: { ...category, isError: true },
      });
      this.categoryField.focus();
      return;
    } else if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: {
          ...euinNo,
          isError: true,
          errorMessage: "EUIN No is mandatory",
        },
      });
      this.euinField.focus();
      return;
    } else if (
      !!others.amount.value &&
      parseFloat(minAmount) > parseFloat(others.amount.value)
    ) {
      this.setState({
        amount: {
          ...others["amount"],
          isError: true,
          errorMessage: `(Minimum Amount should be ${minAmount} ₹)`,
        },
      });
      this.amountField.focus();
      return;
    }
    // else if (+others.amount.value > 1000000) {
    //   this.setState({
    //     amount: {
    //       ...others["amount"],
    //       isError: true,
    //       errorMessage: `Amount should be less than or equal 1,000,000 ₹`,
    //     },
    //   });
    //   this.amountField.focus();
    //   return;
    // }
    else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should not match `,
        },
      });
    } else {
      const { communicationDetails, investorData } = this.props;
      const Xmobile = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.Mobile
      );
      const Xemail = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.email
      );

      const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
      const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
      const params = {
        InvestorName: investorData.invname,
        i_entby: this.props.userId,
        trtype: PURCHASE,
        Desci: "Yes~A~",
        SubbrokerArn: !!this.state.subArnCode.value
          ? `ARN-${subArnCode.value}`
          : "",
        ARNCode: this.state.arnCode.value,
        EuinCode:
          this.state.radioValue.value === "no"
            ? this.state.euinNo.value.value
            : "",
        i_Userid: this.props.userId,
        Mobile: Mobile,
        PanNo: investorData.PAN,
        Email: Email,
        i_Acno: this.state.folio.value.value,

        Subbroker: this.state.subBrokerCode.value,
        i_Fund: "189",
        i_UntAmtValue: this.state.amount.value,
        EUINFlag: this.state.radioValue.value === "no" ? NO : YES,
        EuinValid: this.state.radioValue.value === "no" ? NO : YES,
        // Bankid: `${this.state.bank.value.bnkcode}~${this.state.bank.value.bnkactype}~${this.state.bank.value.bnkacno}`,
        i_Scheme:
          this.state.scheme.value.value.Sch ||
          this.state.scheme.value.value.fm_scheme,
        i_Plan:
          this.state.scheme.value.value.Pln ||
          this.state.scheme.value.value.fm_plan,
        i_Option:
          this.state.scheme.value.value.Opt ||
          this.state.scheme.value.value.fm_option,
        i_oldihno: "0",
        i_InvDistFlag: "B",
        ModuleName: "Webile",
        customfund: "189",
        // comboswitch: !!this.state.isCombo ? "Y" : "N",
      };

      const response = await this.props.submitPurchaseData(params);
      if (response) {
        const {
          DtData: [purchaseData],
        } = response;
        const confirmationParams = {
          Trtype: PURCHASE,
          fund: this.state.fund.value.value,
          Refno: purchaseData.refno,
          ModuleName: "Webile",
          customfund: "189",
        };
        const confirmationResponse = await this.props.showPurchaseConfirmation(
          confirmationParams
        );

        if (!!confirmationResponse) {
          this.props.saveTransactionDetails(this.state);
          this.props.history.push({
            pathname:
              NEW_TRANSACTION_URL +
              "/additional-purchase/digital/transact/confirm",
            state: {
              title: "ADDITIONAL PURCHASE SUMMARY",
              type: ADDITIONAL_PURCHASE,
              scheme: { Fund: this.state.fund.value.value },
              ARNCode: this.state.arnCode.value.split("-")[1],
              subArnCode: this.state.subArnCode.value,
              Folio: this.state.folio.value,
              folio: this.state.folio.value,
              methodType: this.state.schemeType,
            },
          });
        }
      }
    }
  };

  ComboChange = () => {
    this.setState({
      isCombo: !this.state.isCombo,
    });
  };

  keyDown = (label) => (event) => {
    const { folios } = this.state;
    if (folios.length === 0) {
      alert("No Folios Found");
    }
  };

  render() {
    const {
      fund,
      funds = [],
      folio,
      folios = [],
      schemeType,
      schemes = [],
      scheme,
      radioValue,
      arnCode,
      subArnCode,
      subBrokerCode,
      euinNo,
      categories,
      category,
      combo,
      isCombo,
      // bank,
      banks,
      amount,
    } = this.state;
    const { euinList } = this.props;
    return (
      <div className="transaction-details">
        <div className="title">Additional Purchase</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            onFocus={this.keyDown("folios")}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            disabled={!fund.value}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-name">Select Scheme Type</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Existing Scheme"
            width={150}
            active={schemeType === EXISTING}
            onClick={this.changeSchemeType(EXISTING)}
          />
          <Debtbutton
            buttontitle="New Scheme"
            width={150}
            active={schemeType === NEW}
            onClick={this.changeSchemeType(NEW)}
          />
        </div>
        {schemeType === NEW && (
          <div className="input-margin">
            <CustomizedSelect
              name="Category"
              bordercolor="#a6a6a6"
              handleChange={this.handleCategoryChange}
              value={category.value}
              disabled={!folio.value}
              placeholder="Select Category"
              inputRef={(ele) => (this.categoryField = ele)}
              isError={category.isError}
              borderColor="#a6a6a6"
              errorMessage={category.errorMessage}
            >
              {categories.map((item, index) => (
                <MenuItem value={item.CatValue} key={index}>
                  {item.CatDesc}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )}
        <div className="input-margin">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              value: item,
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            disabled={!folio.value}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Input
            name="Minimum Investment Amount (₹)"
            value={amount.value}
            label={this.state.minAmount}
            type="number"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            onBlur={this.showError("amount")}
            onChange={this.changeValue("amount")}
            inputref={(ele) => (this.amountField = ele)}
            bordercolor="#a6a6a6"
            isShowError={amount.isError}
            errorMessage={amount.errorMessage}
          />
        </div>
        <div className="input-margin">
          <Input
            name="ARN Code"
            value={arnCode.value.split("-")[1]}
            disabled={true}
            bordercolor="#a6a6a6"
          />
        </div>
        <div className="input-margin">
          <Input
            name="Sub ARN Code"
            disabled={!fund.value}
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            type="number"
            value={subArnCode.value}
            isShowError={subArnCode.isError}
            errorMessage={subArnCode.errorMessage}
            onBlur={this.validateBrokerCode("189")}
            onChange={this.changeValue("subArnCode")}
            inputref={(ele) => (this.subArnField = ele)}
            bordercolor="#a6a6a6"
          />
        </div>
        <div className="input-margin">
          <Input
            name="Sub Broker Code"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            value={subBrokerCode.value}
            onChange={this.changeValue("subBrokerCode")}
            inputref={(ele) => (this.subBrokerField = ele)}
            bordercolor="#a6a6a6"
            type={"number"}
          />
        </div>
        <div className="input-field-container ">
          <div className="input-name">EUIN Declaration</div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={radioValue.value}
              style={{ flexDirection: "row" }}
              onChange={this.changeValue("radioValue")}
            >
              <div className="investor-radio-button">
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">YES</div>
              </div>
              <div className="investor-radio-button">
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#005DAC" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">NO</div>
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        {radioValue.value === "no" ? (
          <div className="input-margin">
            <IntegrationReactSelect
              suggestions={euinList.map((item) => ({
                value: item.abm_agent,
                label: item.abm_agent,
              }))}
              value={euinNo.value}
              placeholder="Select EUIN"
              handleChange={this.changeEuin}
              errorMessage={euinNo.errorMessage}
              disabled={!euinList.length}
              inputRef={(ele) => (this.euinField = ele)}
              isError={euinNo.isError}
            />
          </div>
        ) : (
          <div className="euin-text">
            I/We hereby confirm that the EUIN box has been intentionally left
            the blank by me/us as this is an 'execution-only' transaction
            without any interaction or advice by any personnel of the above
            distributor or notwithstanding the advice of in-appropriateness,if
            any provided by any personnel of the distributor and the distributor
            has not charged any advisory fees on this transaction
          </div>
        )}
        {/* {combo.flag === "Y" && (
          <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
            <Checkbox
              onClick={this.ComboChange}
              value={combo.label}
              checked={isCombo}
              color="secondary"
            />
            <div
              style={{
                fontSize: 14,
                fontFamily: "Rubik-Bold",
                color: "#283d7c",
              }}
            >
              {combo.label}
            </div>
          </div>
        )} */}
        {/* {combo.flag === "Y" && (
          <div
            style={{
              color: "#283d7c",
              fontSize: 14,
              fontFamily: "Rubik",
              margin: 10,
            }}
          >
            {combo.disclamier}
          </div>
        )} */}
        <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div>
         
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
    } = authReducer;
    const { euinList, transactionDetails } = transactions;
    return {
      fundList,
      token,
      userId,
      euinList,
      bankDetails,
      investorData,
      communicationDetails,
      transactionDetails,
    };
  },
  {
    validateSubBroker,
    getAssetClasses,
    getOtherSchemes,
    submitPurchaseData,
    showPurchaseConfirmation,
    saveTransactionDetails,
  }
)(AdditionalPurchase);
